import { render, staticRenderFns } from "./AddToHomescreen.vue?vue&type=template&id=65743848&scoped=true"
import script from "./AddToHomescreen.vue?vue&type=script&lang=js"
export * from "./AddToHomescreen.vue?vue&type=script&lang=js"
import style0 from "./AddToHomescreen.vue?vue&type=style&index=0&id=65743848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65743848",
  null
  
)

export default component.exports